import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA , MatDialogRef } from '@angular/material/dialog';
import { LabelPreferenceEnum } from 'src/app/core/enumerations/label-preference';
import { PrePrintedLabelDialogData} from 'src/app/core/classes/package';
import { AbstractControl, AsyncValidatorFn, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Observable} from 'rxjs';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { Constants } from 'src/app/shared/constants';
import { ManagePackageService } from '../../feature/order/manage-package/services/manage-package.service';
import { map } from 'rxjs/operators';
import { CustomErrorStateMatcher } from '../error-state-matcher';

@Component({
    selector: 'app-pre-printed-label-dialog',
    templateUrl: './pre-printed-label-dialog.component.html',
    styleUrls: ['./pre-printed-label-dialog.component.scss'],
    standalone: false
})
export class PrePrintedLabelDialogComponent implements OnInit {

  public LabelPrefernceName = 'Label Preference';
  esMatcher = new CustomErrorStateMatcher();
  LabelPreferenceValues = new Array<string>();
  showReqNumber = true;
  packageAccountCode : string;
  packageAccountName : string;
  orderPackageDialogForm : UntypedFormGroup;
  ValidationMessages: any;
  reqNoStatus: any;
  isValidationTriggered:boolean;
  constructor(@Inject(MAT_DIALOG_DATA) public data: PrePrintedLabelDialogData,
  public dialogRef: MatDialogRef<PrePrintedLabelDialogComponent>,private readonly formBuilder: UntypedFormBuilder, private readonly loader: LoaderService,private readonly managePackageService: ManagePackageService) {
  this.packageAccountCode = data.packageAccountCode;
  this.packageAccountName = data.packageAccountName;
   this.LabelPreferenceValues.push(LabelPreferenceEnum.PrintLabels, LabelPreferenceEnum.PrePrintedLabels); 
   this.initializeOrderPackageForm();
   this.orderPackageDialogForm.get('LabelPreference').setValue(LabelPreferenceEnum.PrePrintedLabels);
   
   this.orderPackageDialogForm.setControl('RequisitionNumber', new UntypedFormControl('', {    
    validators: [Validators.required, Validators.pattern(Constants.REQUISITION_REGEX)],
    asyncValidators: [this.asyncReqNoExistsValidator()], updateOn: 'change'
  }));
   }

  ngOnInit(): void {
    // can perform any logical implemention here if required
  }

  initializeOrderPackageForm() {    
    this.orderPackageDialogForm = this.formBuilder.group({      
      LabelPreference: new UntypedFormControl(''),
      RequisitionNumber: new UntypedFormControl('')      
    });
  }  

  private asyncReqNoExistsValidator(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      this.isValidationTriggered = false;
      this.loader.show();      
      return this.checkIfReqNoExists(control.value.toUpperCase()).pipe(
        map(res => {
          this.reqNoStatus = res.message;
          this.isValidationTriggered = true;
          this.loader.hide();
          if (this.reqNoStatus === Constants.REQUISTION_DOESNOT_EXIST_IN_RANGE) {
            return { reqDoesNotExist: true };
          } else if (this.reqNoStatus === Constants.RANGE_DOESNOT_EXIST) {
            return { rangeDoesNotExists: true };
          } else if (this.reqNoStatus === Constants.REQUISITION_USED) {
            return { requisitionUsed: true };
          } else if(this.reqNoStatus === Constants.INVALID_REQUISITION_FORMAT){
            return { invalidRequisitionFormat: true }; 
          } else {
            return null;
          }
        })
      );
    };
  }

  private checkIfReqNoExists(requisitionNumber: string) {
    return this.managePackageService.checkIfReqNoBelongsToLabelrangeByAccCode(this.packageAccountCode, requisitionNumber);
  }

  submitCloseDialog() {
    const request =  new PrePrintedLabelDialogData(); 
    request.usePrePrintedLabels = true;
    request.requistion =  this.orderPackageDialogForm.get('RequisitionNumber').value.toUpperCase();
    if(this.isValidationTriggered && this.reqNoStatus === Constants.REQUISITION_IN_RANGE){
      this.dialogRef.close(request);
    }
  }

  closeDialog()
  {
    this.dialogRef.close();
  }

}


